import Toolbar, { Item } from "devextreme-react/toolbar";
import { useContext } from "react";
import NoteGrid from "../../../common/notes/components/NoteGrid";
import { MaterialOrderContext } from "../context/MaterialOrderContext";
import MaterialOrderAddNoteButton from "./MaterialOrderAddNoteButton";

export default function MaterialOrderNotes() {

	const { order } = useContext(MaterialOrderContext);

	return (
		<>
			<Toolbar className='button-toolbar'>
				<Item location={'before'}>
					<MaterialOrderAddNoteButton />
				</Item>
			</Toolbar>
			<NoteGrid
				notes={order.details.notes}
			/>
		</>
	)
}
